<template>
    <div class="p-3 modal-bg-dark text-white">
        <div class="row">
            <div class="col-md-12">
                <h5>{{transEdit('reserve-treatment')}}</h5>
                <hr>
                <div class="h6 font-weight-bold">{{getDateTime(schedule.start)}}</div>
                <div class="text-muted">{{schedule.location.name}} {{schedule.location.city ? schedule.location.city.name : ''}}</div>
                <div class="text-muted"><img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.therapist.profile_picture_path"> {{schedule.therapist.user.name}}</div>
                <hr>
                <div>
                    <strong>{{transEdit('unbooking-rules')}}</strong>
                    <div>
                        <div>Avbokning <span v-html="latestUnbookDescription(company)"></span> krediteras ditt köp direkt.</div>
                    </div>
                    <div>
                        Avbokas behandlingen efter denna tidpunkt, blir tiden tillgänglig för bokning igen. Köpet kommer endast att krediteras om tiden blir bokad av en annan kund.
                    </div>
                </div>
                <hr>
                <div class="form-group">
                    <label>{{transEdit('treatment')}}</label>
                    <select class="text-gray-500 mb-2" required v-model="selectedTreatment">
                        <option v-if="schedule.treatments.length > 1" disabled selected value="0">{{transEdit('choose-treatment')}}...</option>
                        <option v-for="treatment in schedule.treatments" :value="treatment.id">{{getPrice(treatment)}} - {{treatment.name}}</option>
                    </select>
                </div>
                <div>
                    <button class="btn bg-blue-500 rounded" @click="makeReservation" :disabled="selectedTreatment < 1"><i class="fa fa-check"></i> {{transEdit('reserve')}}</button>
                    <button class="btn text-red-500" @click="$emit('close')"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
    export default {
        name: "booking-modal",
        props: ['schedule', 'company', 'consultant'],
        data(){
          return {
              selectedTreatment: 0
          }
        },
        methods: {
            latestUnbookDescription(company) {
                let returnString = "";
                switch(company.cancel_booking_rule_type) {
                    case 1:
                        let timeArr = company.cancel_booking_before_time.split(":");
                        returnString += " <strong>senast klockan " + timeArr[0] + ":" + timeArr[1] + ",";
                        let daysBefore = company.cancel_booking_before_days;
                        if (daysBefore == 1) {
                            returnString += " 1 dag ";
                        } else {
                            returnString += " " + daysBefore + " dagar ";
                        }
                        returnString += "innan behandlingens början</strong> ";
                        break;
                    case 2:
                        let hoursBefore = company.cancel_booking_before_hours;
                        returnString += " <strong>senast ";
                        if (hoursBefore == 1) {
                            returnString += "1 timme ";
                        } else {
                            returnString += hoursBefore + " timmar ";
                        }
                        returnString += "innan behandlingens början</strong> ";
                        break;
                }

                return returnString;
            },
            makeReservation(){
                if(this.selectedTreatment){
                    axios.post('/reservations/reserve', {
                        'id': this.schedule.id,
                        'treatment_id': this.selectedTreatment,
                        'company_id': this.company.id
                    }).then((res) => {
                        if(res.data[0]) {
                            Vue.toasted.success(res.data[1]);
                            this.schedule.booking = true;
                            this.$emit('close');
                        } else {
                            Vue.toasted.error(res.data[1]);
                        }
                    });
                }
            },
            getPrice(treatment){
                if(treatment.treatment_price){
                    let priceIncVat = 0;
                    if (this.consultant) {
                        priceIncVat = treatment.treatment_price.total_sum * (1 + (treatment.vat / 100));
                    } else {
                        priceIncVat = treatment.treatment_price.subv_total_sum;
                    }
                    return priceIncVat + ' kr';
                }

                return 'Odefinierat pris';
            },
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' +  moment(dateString).format('HH:mm')
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
        },
        mounted(){
            if(this.schedule.treatments.length  == 1){
                this.selectedTreatment = this.schedule.treatments[0].id
            }
        }
    }
</script>

<style scoped>

</style>
